export const getFileBaseName = (fileName: string): string => fileName.replace(/\.[^.]+$/, "");
